import { render, staticRenderFns } from "./CardLeftBlock.vue?vue&type=template&id=2ba420e0"
import script from "./CardLeftBlock.vue?vue&type=script&lang=js"
export * from "./CardLeftBlock.vue?vue&type=script&lang=js"
import style0 from "./CardLeftBlock.vue?vue&type=style&index=0&id=2ba420e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports